import React from "react";
import InstagramIcon from "@material-ui/icons/Instagram";
import GitHubIcon from "@material-ui/icons/GitHub";
import "../styles/Intro.css";
import "react-typist/dist/Typist.css";
import FadeInSection from "./FadeInSection";
import { ReactComponent as Logo } from './logo.svg';

class Intro extends React.Component {
  constructor() {
    super();
    this.state = {
      expanded: true,
      activeKey: "1",
      visible: true,
    };
    this.handleSelect = this.handleSelect.bind(this);
  }
  handleSelect(eventKey) {
    this.setState({
      activeKey: eventKey,
    });
  }
  render() {
    return (
      <div id="intro">
        {/* <FractalTree></FractalTree> */}
        {/* <Typist avgTypingDelay={120}>
          <span className="intro-title">
            {"hi, "}
            <span className="intro-name">{"gazi"}</span>
            {" here."}
          </span>
        </Typist> */}
        <span className="intro-name"> RepairNet</span>
        <FadeInSection>
          <div className="intro-subtitle">Facilities Request Tracker</div>
          <Logo style={{ width: '150px', height: '150px' }} />
          <div className="intro-desc">
          RepairNet aims to improve the efficiency of facilities management by providing students with real-time updates on their requests and scheduled maintenance visits to enhance the student life experience for all the college students living on campus.

          </div>
          <a
            href="https://github.com/jojo142/RepairNet"
            className="intro-contact"
          >
            <GitHubIcon></GitHubIcon>
            {" "}
          </a> &nbsp;&nbsp;&nbsp;
          <a
            href="https://www.instagram.com/repairnet101/"
            className="intro-contact"
          >
            <InstagramIcon> </InstagramIcon>
            {""}
          </a>
        </FadeInSection>
      </div>
    );
  }
}

export default Intro;
